export const phoneCodeByRegionUK = [
    {
        "Destination": "Abu Dhabi",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "AUH",
        "TSRID": "10559",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Ajman",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "31376",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Anguilla",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "ANU",
        "TSRID": "10598",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Antigua",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "ANU",
        "TSRID": "10430",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Aruba",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "AUA",
        "TSRID": "10553",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Bahamas",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "NAS",
        "TSRID": "31302",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Bali",
        "Region": "Indonesia",
        "code": "far-east-holidays",
        "Airport": "DPS",
        "TSRID": "11884",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Bangkok",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "BKK",
        "TSRID": "10877",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Barbados",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "BGI",
        "TSRID": "10785",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Bermuda",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "BDA",
        "TSRID": "10714",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Borneo",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "BKI",
        "TSRID": "10875",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Cancun & Caribbean Coast",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "CUN",
        "TSRID": "11623",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Cape Town",
        "Region": "South Africa",
        "code": "africa-holidays",
        "Airport": "CPT",
        "TSRID": "11537",
        "ClassName": "rTapNumber164884",
        "phone": "01342 331 797",
        "phoneHref": "01342331797"
    },
    {
        "Destination": "Chiang Mai",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "CNX",
        "TSRID": "11498",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Cayman Islands",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "GCM",
        "TSRID": "12422",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Da Nang",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "DAD",
        "TSRID": "11712",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Dominican Republic",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "PUJ",
        "TSRID": "15805",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Dubai",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "11945",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Dubai and the Emirates",
        "Region": "middle-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148974",
        "TSRID": "01342 331795",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "East Coast and Kuantan",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "KUL",
        "TSRID": "17425",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Fujairah",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "31535",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Grenada",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "GND",
        "TSRID": "12549",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Grenadines",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "SVD",
        "TSRID": "31350",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Hoi An",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "DAD",
        "TSRID": "31296",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Hong Kong",
        "Region": "Asia",
        "code": "far-east-holidays",
        "Airport": "HKG",
        "TSRID": "12808",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Hua Hin and Cha Am",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "BKK",
        "TSRID": "12785",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Johannesburg",
        "Region": "South Africa",
        "code": "africa-holidays",
        "Airport": "JNB",
        "TSRID": "13298",
        "ClassName": "rTapNumber164884",
        "phone": "01342 331 797",
        "phoneHref": "01342331797"
    },
    {
        "Destination": "Kenya",
        "Region": "africa-holidays",
        "code": "0",
        "Airport": "rTapNumber164884",
        "TSRID": "01342 331 797",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "Khanom",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "USM",
        "TSRID": "31358",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Khao Lak",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "31293",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Koh Lanta",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "KBV",
        "TSRID": "31294",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Koh Phangan",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "USM",
        "TSRID": "31443",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Koh Samui",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "USM",
        "TSRID": "31445",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Koh Yao",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "31445",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Krabi",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "KBV",
        "TSRID": "13405",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Kuala Lumpur",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "KUL",
        "TSRID": "13769",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Langkawi",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "LGK",
        "TSRID": "13961",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Malaysia",
        "Region": "far-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148975",
        "TSRID": "01342 310 571",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "Maldives",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "MLE",
        "TSRID": "19381",
        "ClassName": "rTapNumber164873",
        "phone": "01342 310 589",
        "phoneHref": "01342310589"
    },
    {
        "Destination": "Mauritius",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "MRU",
        "TSRID": "14672",
        "ClassName": "rTapNumber164873",
        "phone": "01342 310 589",
        "phoneHref": "01342310589"
    },
    {
        "Destination": "Mexico",
        "Region": "caribbean-holidays",
        "code": "0",
        "Airport": "rTapNumber164878",
        "TSRID": "01342 310596",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "Mombasa",
        "Region": "Kenya",
        "code": "africa-holidays",
        "Airport": "MBA",
        "TSRID": "14286",
        "ClassName": "rTapNumber164884",
        "phone": "01342 331 797",
        "phoneHref": "01342331797"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Nha Trang",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "CXR",
        "TSRID": "30202",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Oman",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "MCT",
        "TSRID": "14327",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Pangkor",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "KUL",
        "TSRID": "32681",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Phan Thiet",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "SGN",
        "TSRID": "31478",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Phi Phi Islands",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "15550",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Phuket",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "19391",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "Qatar",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DOH",
        "TSRID": "11866",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Ras Al Khaimah",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "16567",
        "ClassName": "rTapNumber148974",
        "phone": "01342 331795",
        "phoneHref": "01342331795"
    },
    {
        "Destination": "Reunion",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "RUN",
        "TSRID": "31356",
        "ClassName": "rTapNumber164873",
        "phone": "01342 310 589",
        "phoneHref": "01342310589"
    },
    {
        "Destination": "Cancun & Caribbean Coast",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "CUN",
        "TSRID": "11623",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Seychelles",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "SEZ",
        "TSRID": "31542",
        "ClassName": "rTapNumber164873",
        "phone": "01342 310 589",
        "phoneHref": "01342310589"
    },
    {
        "Destination": "Singapore",
        "Region": "Asia",
        "code": "far-east-holidays",
        "Airport": "SIN",
        "TSRID": "16907",
        "ClassName": "rTapNumber148975",
        "phone": "01342 310 571",
        "phoneHref": "01342310571"
    },
    {
        "Destination": "South Africa",
        "Region": "africa-holidays",
        "code": "0",
        "Airport": "rTapNumber164884",
        "TSRID": "01342 331 797",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "Sri Lanka",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "CMB",
        "TSRID": "31543",
        "ClassName": "rTapNumber164873",
        "phone": "01342 310 589",
        "phoneHref": "01342310589"
    },
    {
        "Destination": "St Kitts and Nevis",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "SKB",
        "TSRID": "16943",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "St Lucia",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "UVF",
        "TSRID": "16984",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Sun City",
        "Region": "South Africa",
        "code": "africa-holidays",
        "Airport": "DUR",
        "TSRID": "15102",
        "ClassName": "rTapNumber164884",
        "phone": "01342 331 797",
        "phoneHref": "01342331797"
    },
    {
        "Destination": "Thailand",
        "Region": "far-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148975",
        "TSRID": "01342 310 571",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "Tobago",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "TAB",
        "TSRID": "17311",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "rTapNumber164878",
        "phone": "01342 310596",
        "phoneHref": "01342310596"
    },
    {
        "Destination": "Vietnam",
        "Region": "far-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148975",
        "TSRID": "01342 310 571",
        "ClassName": "",
        "phone": ""
    },
    {
        "Destination": "Zanzibar",
        "Region": "Africa",
        "code": "africa-holidays",
        "Airport": "ZNZ",
        "TSRID": "19235",
        "ClassName": "rTapNumber164884",
        "phone": "01342 331 797",
        "phoneHref": "01342331797"
    }
]